import React, { memo } from 'react';
import { useSelector } from 'react-redux';

import { Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { selectPriorToNameByValue } from 'store/underwriting/selectors';

import { UnderwritingTestIds } from '../../Underwriting.testIds';

import LoanConditionTable from './loanConditionTable';

const LoanCondition = ({ priorTo, conditions }) => {
  const priorToDisplayName = useSelector(selectPriorToNameByValue(priorTo));
  const conditionsAmount = conditions.filter(({ signedOff }) => !signedOff).length;

  return (
    <>
      <div
        className="flex items-center min-h-40 mt-20"
        data-testid={UnderwritingTestIds.getConditionHeaderId(priorTo)}
      >
        <Typography className="mb-20" variant="bold16">
          {`Conditions: Prior To ${priorToDisplayName} (${conditionsAmount})`}
        </Typography>
      </div>
      <LoanConditionTable conditions={conditions} />
    </>
  );
};

LoanCondition.propTypes = {
  priorTo: PropTypes.string.isRequired,
  conditions: PropTypes.array.isRequired,
};

export default memo(LoanCondition);
